var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gradient-background',[_c('center-card',{scopedSlots:_vm._u([{key:"card-title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('login.title'))+" ")]},proxy:true},{key:"card-body",fn:function(){return [_c('login-form')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }